import styled from 'styled-components';
import { colorUsage } from 'stylesheet';
import { Tag } from 'theme/icons';
export var StyledTag = styled(Tag).withConfig({
  displayName: "TagInputTextFieldstyle__StyledTag",
  componentId: "sc-1192xpg-0"
})(["width:20px;height:20px;path{fill:", ";}"], colorUsage.defaultIconColor);